import React, { SVGProps } from 'react';

const DiscordIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 26 20"
			fill="none"
			{...props}
		>
			<mask
				id="mask0_24558_10354"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="26"
				height="20"
			>
				<path d="M25.5 0.5H0.5V19.8878H25.5V0.5Z" fill="white" />
			</mask>
			<g mask="url(#mask0_24558_10354)">
				<path
					d="M21.6636 2.22589C20.0701 1.49395 18.3614 0.954684 16.5749 0.645827C16.5424 0.639866 16.5099 0.654763 16.4931 0.684556C16.2733 1.07584 16.0299 1.5863 15.8595 1.98752C13.9379 1.69953 12.0262 1.69953 10.1441 1.98752C9.97359 1.57738 9.72134 1.07584 9.5006 0.684556C9.48384 0.655757 9.45134 0.64086 9.4188 0.645827C7.63324 0.953697 5.92454 1.49296 4.33014 2.22589C4.31634 2.23184 4.30451 2.24178 4.29666 2.25469C1.05562 7.10212 0.16776 11.8304 0.603313 16.5001C0.605283 16.5229 0.618094 16.5448 0.635831 16.5587C2.77418 18.1308 4.84553 19.0852 6.87842 19.7178C6.91095 19.7277 6.94542 19.7158 6.96613 19.689C7.44701 19.0315 7.87567 18.3383 8.2432 17.6094C8.26489 17.5667 8.24419 17.516 8.19986 17.4991C7.51993 17.2409 6.8725 16.9261 6.24972 16.5686C6.20046 16.5398 6.19651 16.4693 6.24183 16.4355C6.37289 16.3372 6.50398 16.2349 6.62912 16.1316C6.65176 16.1127 6.68331 16.1088 6.70993 16.1207C10.8013 17.9907 15.2308 17.9907 19.2739 16.1207C19.3005 16.1078 19.3321 16.1117 19.3557 16.1306C19.4809 16.2339 19.6119 16.3372 19.744 16.4355C19.7893 16.4693 19.7863 16.5398 19.7371 16.5686C19.1143 16.933 18.4669 17.2409 17.7859 17.4981C17.7416 17.515 17.7219 17.5667 17.7436 17.6094C18.119 18.3373 18.5477 19.0305 19.0197 19.688C19.0394 19.7158 19.0749 19.7277 19.1074 19.7178C21.1501 19.0852 23.2215 18.1308 25.3598 16.5587C25.3786 16.5448 25.3904 16.5239 25.3924 16.5011C25.9136 11.1024 24.5193 6.4129 21.6961 2.25567C21.6892 2.24178 21.6774 2.23184 21.6636 2.22589ZM8.85419 13.6567C7.62239 13.6567 6.60743 12.5246 6.60743 11.1342C6.60743 9.74382 7.60271 8.61168 8.85419 8.61168C10.1155 8.61168 11.1206 9.75376 11.1009 11.1342C11.1009 12.5246 10.1056 13.6567 8.85419 13.6567ZM17.1612 13.6567C15.9294 13.6567 14.9145 12.5246 14.9145 11.1342C14.9145 9.74382 15.9097 8.61168 17.1612 8.61168C18.4225 8.61168 19.4276 9.75376 19.408 11.1342C19.408 12.5246 18.4225 13.6567 17.1612 13.6567Z"
					fill="currentColor"
				/>
			</g>
		</svg>
	);
};

export default DiscordIcon;
